export class SortUtils {

  public static sortStrings(a: string, b: string) {
    a = (a === undefined || a === '') ? "---" : a.toLowerCase()
    b = (b === undefined || b === '') ? "---" : b.toLowerCase()

    if (a < b) {
      return -1
    }
    if (a > b) {
      return 1
    }
    return 0
  }

  public static sortNumbers(a: number, b: number) {
    return a - b
  }

  public static sortDates(a: string, b: string) {
    if (a && b) {
      const parsedDateA = Date.parse(a)
      const parsedDateB = Date.parse(b)

      if (parsedDateA < parsedDateB) {
        return -1
      }
      if (parsedDateA > parsedDateB) {
        return 1
      }
      return 0
    }
    return 0
  }
}